import { NgModule } from "@angular/core";
import { audioChannelPresetProvider } from "../components/common-form/special-fields/audio-configurations/templates";
import { AudioConfigMostCommonLanguagePipe, AudioConfigShorthandPipe, SeparateFilesShorthandPipe } from "./audio-config.pipe";
import { BreakLengthPipe } from "./break-length.pipe";
import { CapitalizationPipe } from "./capitalization.pipe";
import { FormattedFileTypePipe } from "./formatted-file-types.pipe";
import { JoinPipe } from "./join.pipe";
import { LineBreaksPipe } from "./line-breaks.pipe";
import { MillisecondsToMinutesSecondsPipe } from "./milliseconds-to-minutes-seconds.pipe";
import { OrNotAvailPipe } from "./or-not-avail.pipe";
import { OutputFilePresentPipe } from "./output-files.pipe";
import { RuntimePipe } from "./runtime.pipe";
import { StartCasePipe } from "./start-case.pipe";
import { UTCDateObjectPipe, UTCFormattedDatePipe } from "./utc-date.pipe";
import { YesNoPipe } from "./yes-no.pipe";

@NgModule({
    declarations: [
        AudioConfigShorthandPipe,
        AudioConfigMostCommonLanguagePipe,
        StartCasePipe,
        RuntimePipe,
        BreakLengthPipe,
        JoinPipe,
        OrNotAvailPipe,
        LineBreaksPipe,
        OutputFilePresentPipe,
        FormattedFileTypePipe,
        SeparateFilesShorthandPipe,
        UTCFormattedDatePipe,
        UTCDateObjectPipe,
        YesNoPipe,
        MillisecondsToMinutesSecondsPipe,
        CapitalizationPipe,
    ],
    exports: [
        AudioConfigShorthandPipe,
        AudioConfigMostCommonLanguagePipe,
        StartCasePipe,
        RuntimePipe,
        BreakLengthPipe,
        JoinPipe,
        OrNotAvailPipe,
        LineBreaksPipe,
        OutputFilePresentPipe,
        FormattedFileTypePipe,
        SeparateFilesShorthandPipe,
        UTCFormattedDatePipe,
        UTCDateObjectPipe,
        YesNoPipe,
        MillisecondsToMinutesSecondsPipe,
        CapitalizationPipe,
    ],
    providers: [
        audioChannelPresetProvider,
        OrNotAvailPipe,
        LineBreaksPipe,
        YesNoPipe,
    ],
})
export class SharedPipesModule {
}
